'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutCluster, LayoutStack } from 'design-system/client';
import { useTranslations } from 'next-intl';
import styles from './MessageField.module.css';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import FormCheckbox from '@/form/FormCheckbox';
import FormInput from '@/form/FormInput';
import FormTextArea from '@/form/FormTextArea';
function getFullName({
  firstName,
  lastName
}: {
  firstName?: string;
  lastName?: string;
}) {
  if (!firstName && !lastName) return '';
  if (!lastName) return firstName;
  if (!firstName) return lastName;
  return `${firstName} ${lastName.substring(0, 1) + '.'}`;
}
function ShowUserLabel() {
  const $ = _c(16);
  const t = useTranslations("nextjs.donate");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["_company_donation", "company_name", "first_name", "last_name"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [companyDonation, companyName, firstName, lastName] = useDonationFormValues(t0);
  let t1;
  if ($[1] !== companyDonation || $[2] !== companyName || $[3] !== firstName || $[4] !== lastName) {
    t1 = companyDonation ? companyName ?? "" : getFullName({
      firstName,
      lastName
    }) ?? "";
    $[1] = companyDonation;
    $[2] = companyName;
    $[3] = firstName;
    $[4] = lastName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const displayName = t1;
  let t2;
  if ($[6] !== displayName) {
    t2 = displayName.length > 18 ? `${displayName.substring(0, 18)}...` : displayName;
    $[6] = displayName;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const trimmedDisplayName = t2;
  if (!trimmedDisplayName) {
    let t3;
    if ($[8] !== t) {
      t3 = t("show_user.label");
      $[8] = t;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t3) {
      t4 = <>{t3}</>;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t3;
  if ($[12] !== t) {
    t3 = t("show_user.label");
    $[12] = t;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const t4 = `${t3}: ${trimmedDisplayName}`;
  let t5;
  if ($[14] !== t4) {
    t5 = <>{t4}</>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function MessageField() {
  const $ = _c(20);
  const t = useTranslations("nextjs.donate");
  const {
    isStreamingEvent
  } = useDonationFormConfig();
  let t0;
  if ($[0] !== isStreamingEvent || $[1] !== t) {
    t0 = isStreamingEvent && <DonationFormField name="display_name" as={FormInput} label={t("attributes.display_name")} />;
    $[0] = isStreamingEvent;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t) {
    t1 = t("attributes.message");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <DonationFormField name="message" as={FormTextArea} label={t1} rows={1} />;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("show_amount.label");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <DonationFormField name="show_amount" as={FormCheckbox}>{t3}</DonationFormField>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isStreamingEvent) {
    t5 = !isStreamingEvent && <DonationFormField name="show_user" as={FormCheckbox}><ShowUserLabel /></DonationFormField>;
    $[11] = isStreamingEvent;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <LayoutCluster space="250" className={styles.checkboxes}>{t4}{t5}</LayoutCluster>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t0 || $[17] !== t2 || $[18] !== t6) {
    t7 = <LayoutStack space="300">{t0}{t2}{t6}</LayoutStack>;
    $[16] = t0;
    $[17] = t2;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
export default MessageField;